export var GraphData = {
	methods: {},
	computed: {
		graphData: function() {
			return {
				title: {
					text: this.getNameOfGraph ? this.getNameOfGraph : "",
					show: true,
					left: "center",
					top: 20, // title top spacing
					bottom: 10,
					padding: [0, 0, 15, 0],
					textStyle: {
						color: "#484848"
					}
				},
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow"
					},
					// formatter: function (params) {
					// 	for(let i in params) {
					// 		return `${params[i].seriesName}: ${params[i].value}`;
					// 	}
					// 	console.log(params)
						
					//   }
					// formatter: '{b}: {c}%',
				},
				legend: this.graphLegend,
				grid: this.grid,
				yAxis: this.graphYaxis,
				xAxis: this.graphXaxis,
				color: this.graphColors,
				series: this.graphSeries
			};
		}
	},
	data() {
		return {
			graphLegend: {
				// type: "scroll",
				itemGap: 10,
				top: 50, // legend top spacing
				bottom: 30,
				show: true,
				textStyle: {
					color: "#484848"
				}
			},
			// graphColors: ["#f9acaa", "#ffb133", "#409eff"],
			graphColors: ["#e29d5a", "#f9cb9c", "#fce5cd"],
			graphSeries: [],
			graphYaxis: [
				{
					type: "value",
					name: ""
					// min: 0,
					// max: 250,
					// interval: 50,
					// axisLabel: {
					//     formatter: '{value} ml'
					// }
				},
				{
					type: "value",
					name: ""
					// min: 0,
					// max: 25,
					// interval: 5,
					// axisLabel: {
					//     formatter: '{value} °C'
					// }
				}
			],
			grid: {
				top: "30%", // graph top spacing
				bottom: "20%", // graph bottom spacing
				right: "15%", // graph right spacing
				left: "15%" // graph left spacing
			},
			graphXaxis: [
				{
					type: "category",
					// boundaryGap: false,
					data: [],
					scale: true,
					min: 0,
					max: "",
					axisLabel: {
						// interval: 0,
						// rotate: 90,
						margin: 20,
						formatter: function(d) {
							return d;
						}
					}
				}
			],
			initOptions: { renderer: "svg" },
			loading: true
		};
	}
};
